<template>
    <td-dialog :title="$t('pki.PKI_SET')" :before-close="close" :visible.sync="dialogPKIVisible" width="370px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form @submit.native.prevent :model="formPKIInfo" ref="formPKIInfo" label-position="right" label-width="100px" :rules="rules">
            <el-form-item :label="$t('pki.MANUFACTOR_NAME')" prop="name">
                <td-input v-model="formPKIInfo.name" :maxlength="100"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pki.MANUFACTOR_PATH')" prop="path">
                <td-input v-model="formPKIInfo.path" :maxlength="300"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pki.PKI_STATUS')" prop="status">
                <td-switch v-model="formPKIInfo.status" :activeText="$t('pki.PKI_ENABLE')" :inactiveText="$t('pki.PKI_DISABLE')" :activeValue="0" :inactiveValue="1"></td-switch>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="save()" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="close">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: ['editItem', 'dialogPKIVisible'],
    created() {
        this.formPKIInfo.id = this.editItem.id;
        this.formPKIInfo.name = this.editItem.name;
        this.formPKIInfo.path = this.editItem.path;
        this.formPKIInfo.status = this.editItem.status;
    },
    // 定义变量
    data() {
        return {
            loading: false,
            formPKIInfo: {
                id: '',
                name: '',
                path: '',
                status: 0
            },
            rules: {
                name: [{ required: true, message: this.$t('pki.INPUT_MANUFACTOR_NAME'), trigger: 'blur' }, { pattern: this.$regex.CAPTION_RULE, message: this.$t('pki.NAME_ILLEGAL_AlARM') }],
                path: [{ required: true, message: this.$t('pki.INPUT_MANUFACTOR_PATH'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        save() {
            this.$refs['formPKIInfo'].validate(valid => {
                if (valid) {
                    let param = this.formPKIInfo;
                    api.editPKIInfo(JSON.stringify(param), response => {
                        this.loading = false;
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$log.error('/auth/pkiLogin/editPKIInfo', response);
                            return;
                        }
                        if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/auth/pkiLogin/editPKIInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('pki.PKI_SET_SUCCESS'), type: 'success' });
                        this.close();
                    });
                }
            });
        },
        close() {
            this.$emit('dialogClose');
        }
    }
};
</script>
<style></style>
